import { render, staticRenderFns } from "./divider-widget.vue?vue&type=template&id=475a9562&scoped=true"
import script from "./divider-widget.vue?vue&type=script&lang=js"
export * from "./divider-widget.vue?vue&type=script&lang=js"
import style0 from "./divider-widget.vue?vue&type=style&index=0&id=475a9562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475a9562",
  null
  
)

export default component.exports